import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { SiteWrapper } from 'src/app';
import React, { Suspense } from 'react';
import { Loader } from 'src/redesign/components/Loader';

const WidgetsPage = React.lazy(() =>
  import('src/modules/sites/widgets').then((module) => ({ default: module.Widgets })),
);

const TeamInviteLoadedPage = React.lazy(() =>
  import('src/redesign/pages/TeamInvitePage').then((module) => ({
    default: module.TeamInvitePage,
  })),
);

const OrganizationSetupPageLoaded = React.lazy(() =>
  import('src/redesign/pages/OrganizationSetupPage').then((module) => ({
    default: module.OrganizationSetupPage,
  })),
);

const OrganizationSettingsPageLoaded = React.lazy(() =>
  import('src/redesign/pages/OrganizationSettingsPage').then((module) => ({
    default: module.OrganizationSettingsPage,
  })),
);

const OrganizationTeamPageLoaded = React.lazy(() =>
  import('src/redesign/pages/OrganizationTeamPage').then((module) => ({
    default: module.OrganizationTeamPage,
  })),
);

const OrganizationPageLoaded = React.lazy(() =>
  import('src/redesign/pages/OrganizationPage').then((module) => ({
    default: module.OrganizationPage,
  })),
);

export const SiteRouter = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route
        exact
        path={`${path}/:site_id/widgets`}
        render={(props) => (
          <Suspense fallback={<Loader />}>
            <SiteWrapper {...props}>
              <WidgetsPage />
            </SiteWrapper>
          </Suspense>
        )}
      />
      <Route
        exact
        path={`${path}/:site_id/team`}
        render={(props) => (
          <Suspense fallback={<Loader />}>
            <SiteWrapper {...props}>
              <TeamInviteLoadedPage />
            </SiteWrapper>
          </Suspense>
        )}
      />
      <Route
        exact
        path={`${path}/:site_id/organization/team`}
        render={(props) => (
          <Suspense fallback={<Loader />}>
            <SiteWrapper {...props}>
              <OrganizationTeamPageLoaded />
            </SiteWrapper>
          </Suspense>
        )}
      />
      <Route
        exact
        path={`${path}/:site_id/organization/:tab`}
        render={(props) => (
          <Suspense fallback={<Loader />}>
            <SiteWrapper {...props}>
              <OrganizationPageLoaded />
            </SiteWrapper>
          </Suspense>
        )}
      />
    </Switch>
  );
};
